export const BOOTSTRAP_NAMESPACE = 'formBuilder';

export const INPUT_TYPE_DISPLAY_NAMES = 'inputTypeDisplayNames';
export const INPUT_TYPE_SHORT_NAMES = 'inputTypeShortNames';
export const INPUT_TYPES = 'allowedInputTypes';
export const INPUT_TYPE_CONFIGURATIONS = 'allowedInputTypeConfigurations';
export const FLAGS = 'flags';
export const FORM_CONFIG = 'formConfig';
export const ENABLED_SCALED_FORMS = 'enabledScaledForms';
